'use client';

import { MusiCalPopup } from './MusiCalPopup';
import { Instrument } from '@/app/instruments';

interface MobileStickyCTAProps {
  instrument: Instrument;
  text?: string;
}

export function MobileStickyCTA({ instrument, text = 'Book Free Trial Now' }: MobileStickyCTAProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-green-600 p-4 md:hidden z-50 shadow-lg">
      <MusiCalPopup instrument={instrument}>
        <button className="w-full text-white font-bold py-3 rounded-lg bg-green-700 hover:bg-green-800 transition-colors">
          {text}
        </button>
      </MusiCalPopup>
    </div>
  );
}